export const getDocumentTypeByCode = (code: string) => {
    switch (code) {
      case "PSU001":
        return "TGSS"

      case "PSU002":
        return "AEAT"

      case "PWU001":
        return "RNT/RECIBO/A1"

      case "PWU002":
        return "IDC/IDC RETA"

      case "PRL006":
        return "PRL"
      default:
        return code;
    }
  }